import React from "react";
import deleteIcon from "media/icons/dls/delete.svg";
import "./DeleteImageComponent.scoped.scss";

interface TableImageProps {
    handleDeleteImg: () => void;
}
const DeleteImageComponent: React.FC<TableImageProps> = ({ handleDeleteImg }) => {
    return (
        <div className="rdw-option-wrapper delete-img-icon" onClick={() => { handleDeleteImg() }}>
            <img
                src={deleteIcon}
                title="Click this button to delete the image in the table cell"
                className="icon-small"
                alt='delete icon'
            />
        </div>
    );
}

export default DeleteImageComponent;